import { isServer } from '@/shared/util/ssr';
import { LocalStorageKey } from '../LocalStorageKey';

export function getAccessToken(): string {
  if (isServer) {
    return '';
  }

  return localStorage.getItem(LocalStorageKey.ACCESS_TOKEN) || '';
}

export function setAccessToken(accessToken: string) {
  if (isServer) {
    return;
  }

  localStorage.setItem(LocalStorageKey.ACCESS_TOKEN, accessToken);
}
